import { render } from "./UIDialog.vue?vue&type=template&id=003c709a&scoped=true"
import script from "./UIDialog.vue?vue&type=script&lang=js"
export * from "./UIDialog.vue?vue&type=script&lang=js"

import "./UIDialog.vue?vue&type=style&index=0&id=003c709a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003c709a"]])

export default __exports__